export const travelModes = ["car", "motorcycle", "bicycle", "scooter", "taxi", "bus", "walking"] as const;
export type TravelMode = typeof travelModes[number];
export const transportLabels: Record<TravelMode, string> = {
  car: "רכב פרטי", motorcycle: "אופנוע", bicycle: "אופניים", scooter: "קורקינט", taxi: "מונית", bus: "אוטובוס",
  walking: "הליכה",
};
export const transportNotes: Record<TravelMode, string> = {
  car: "מסלול בכבישים לרכב פרטי",
  motorcycle: "מסלול לאופנוע לפי הרשאות הדרך במפה",
  bicycle: "עדיפות לשבילי אופניים ולדרכים שקטות, ללא מדרגות",
  scooter: "מסלול רכיבה ללא מדרגות, עם העדפה לשבילים ולמשטח סלול",
  taxi: "מסלול כביש למונית; אינו מניח היתר לנסיעה בנתיבי תחבורה ציבורית",
  bus: "קווים, תחנות ולוחות זמנים לנוסעים",
  walking: "מסלול להולכי רגל דרך שבילים ומעברים; עשוי לכלול מדרגות",
};
export function isTravelMode(value: unknown): value is TravelMode {
  return travelModes.includes(value as TravelMode);
}
export function usesRoadTraffic(mode: TravelMode) { return mode === "car" || mode === "taxi"; }
export function isCycling(mode: TravelMode) { return mode === "bicycle" || mode === "scooter"; }
